import React from 'react'

import { Button } from '@/components/ui/button'
import RenderIf from '@/components/ui/render-if'
import { Text } from '@/components/ui/text'
import { CommonArrowLeft, CommonHome } from '@/icons'
import { cn } from '@/lib'

import { useNavigate } from 'react-router-dom'

interface NavigationHeaderProps {
  title: string
  isShowHome?: boolean
  onBack?: () => void
  isShowBack?: boolean
  className?: string
  onGoHome?: () => void
  rightElement?: React.ReactNode
}

const NavigationHeader: React.FC<NavigationHeaderProps> = ({
  title,
  isShowHome = true,
  onBack,
  onGoHome,
  isShowBack = true,
  className = '',
  rightElement,
}) => {
  const navigate = useNavigate()

  const handleBackClick = () => {
    if (onBack) {
      onBack()
    } else {
      try {
        window.history.state && window.history.state.idx > 0 ? navigate(-1) : navigate('/')
      } catch {
        navigate('/')
      }
    }
  }

  return (
    <div className={cn('flex w-full pb-3 justify-between items-center ', className)}>
      <div className='flex items-center gap-x-2.5'>
        <RenderIf condition={isShowBack}>
          <Button variant='icon' size='sm' onClick={handleBackClick} className='bg-transparent group w-8'>
            <CommonArrowLeft className='size-5 md:size-6' />
          </Button>
        </RenderIf>
        <Text as='h2' size={18}>
          {title}
        </Text>
      </div>
      <RenderIf condition={!isShowBack}>
        <div></div>
      </RenderIf>
      <RenderIf condition={rightElement}>{rightElement}</RenderIf>
      <RenderIf condition={isShowHome}>
        <Button
          variant='icon'
          size='sm'
          onClick={onGoHome || (() => navigate('/'))}
          className='bg-transparent group w-8'
        >
          <CommonHome className='size-5 md:size-6 cursor-pointer' />
        </Button>
      </RenderIf>
      <RenderIf condition={!isShowHome && !rightElement}>
        <div></div>
      </RenderIf>
    </div>
  )
}

export default NavigationHeader
